import {
  useMutation,
  UseMutationResult,
  useQuery,
} from '@tanstack/react-query';
import useApi from 'api/mavapi/useApi';
import { DataUploadsService } from 'api/openapi';
import { useOnErrorCallBack } from './useErrorHandling';
import React from 'react';
export const useDataUploadApi = () => {
  const { handleRequest } = useApi();
  const { onErrorCallBack } = useOnErrorCallBack();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const useGetDataUploadsData = (): UseMutationResult<
    any, // Response type
    Error, // Error type
    {
      uploadCode?: string;
    } // Variables type
  > => {
    return useMutation({
      mutationFn: async ({ uploadCode }) => {
        // code parameter use for later, now dummy code applied _code
        let _code = 'uploadDataDummyCode';

        setIsLoading(true);
        const response = await handleRequest(
          DataUploadsService.getApiDataUploads(_code),
        );
        return { data: response };
      },
      onSuccess: response => {
        setIsLoading(false);
        if (response && response.data.url) {
          // Open the url in a new tab
          window.open(response.data.url, '_blank');
        }
      },
      onError: error => {
        setIsLoading(false);
        onErrorCallBack(error);
      },
    });
  };
  return {
    useGetDataUploadsData,
    isLoading,
  };
};
